import {NeoGlobalService, NeoStorageService, NeoLangService} from 'ng-neo';
import {Component, ViewContainerRef, OnInit, AfterViewInit} from '@angular/core';
import {NavigationStart, Router} from '@angular/router';
import {NeoRestService} from 'app/core/services/neo-rest/neo-rest.service';
import {NgProgress} from '@ngx-progressbar/core';
import {ToastrService} from "ngx-toastr";
import {NeoACLService} from "./core/services/neo-acl/neo-acl";

@Component({
    selector: 'app-root',
    template: `
        <ng-progress [spinner]="false" [color]="'#eb443d'"></ng-progress>
        <router-outlet></router-outlet>`
})
export class AppComponent implements OnInit, AfterViewInit {

    public constructor(private viewContainerRef: ViewContainerRef,
                       private _gs: NeoGlobalService,
                       private _storage: NeoStorageService,
                       private _router: Router,
                       private _rest: NeoRestService,
                       private _lang: NeoLangService,
                       private _ngProgrees: NgProgress,
                       private toastr: ToastrService,
                       private _acl: NeoACLService,
    ) {
    }

    ngOnInit(): void {
        // Estado inicial de la aplicación
        this._gs.set('isLogin', true);

        let user = this._storage.getNeoUser();
        if (user) {
            user.NeoPermission = user.NeoPermission || {};
            user.NeoPermission.Groups = user.NeoPermission.Groups || [];
            this._acl.setAbilities(user.NeoPermission.Groups);
            this._acl.setUserType(user.NeoUserType);
        }

        this._gs.subscribe('isLogin', ({current}) => {
            // Si no esta logeado lo devolvemos al login
            if (!current) {
                this._storage.removeNeoUser();
                this._router.navigate(['/auth/login']);
                return;
            }
        });

        this._router.events.subscribe((event) => {
            // Si el evento es de final de navegacion
            // Seteamos el porcentaje
            if (event instanceof NavigationStart) {
                this._ngProgrees.start();
            } else {
                this._ngProgrees.complete();
            }
        });

        this._gs.subscribe('loading', ({current}) => {
            if (!isNaN(current)) {
                this._ngProgrees.inc(current / 100);

                this._ngProgrees.set(current);
                return;
            }

            if (current === 'start') {
                this._ngProgrees.complete();
                return;
            }

            this._ngProgrees.complete();
        });

        // Iniciamizamos el array de extras
        this._gs.set('alerts', []);

        // Estado del menu izquierdo
        this._gs.set('menu.isCollapsed', false);

        // Estado del campo de busqueda del header
        this._gs.set('header.searchText', null);

        this._gs.set('currentSection.title', null);

        // this._gs.subscribe('lang', ({current}) => {
        //     if (!current) {
        //         current = '';
        //     }
        //
        //     this.getLangs(current);
        // });

        this._gs.set('lang', null);

        // Iniciamos el valor de si estamos notificados por la caducidad de la sesión
        this._gs.set('isNotifiedBySession', false);

        // Tamaño de ventana
        this._gs.set('windowsize', window.innerWidth);

        // LastUpdate de la aplicacion
        this._gs.set('lastupdate', new Date(document.querySelector("html").getAttribute("data-lastupdate")));

        this._gs.subscribe('newVersion', ({previous}) => {
            if (!previous) {
                this.toastr.info("Hay una nueva actualización en el servidor. Click para refrescar", "Nueva versión", {
                    disableTimeOut: true,
                    tapToDismiss: false,
                    enableHtml: true
                })
                    .onTap.subscribe(() => {
                    window.location.reload(true);
                });
            }
        });
    }

    // private getLangs(lang = '') {
    //     this._initLang.setLanguage(lang);
    // }

    public ngAfterViewInit(): void {
        // Cuando la vista esta lista escondemos el spinner
        this._gs.set('loading', 0);
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts